"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.addToFavorites = exports.removeFromFavorites = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var setValueToLocalStorage_1 = require("../../helpers/localStorage/setValueToLocalStorage");
var getValueFromLocalStorage_1 = require("../../helpers/localStorage/getValueFromLocalStorage");
var favoritesList = (0, getValueFromLocalStorage_1.getValueFromLocalStorage)('favorites', []);
var initialState = {
    favoritesList: favoritesList,
    favoritesCount: favoritesList.length,
};
var favoritesSlice = (0, toolkit_1.createSlice)({
    name: 'favorites',
    initialState: initialState,
    reducers: {
        addToFavorites: function (state, action) {
            state.favoritesList.push(action.payload);
            state.favoritesCount = state.favoritesList.length;
            (0, setValueToLocalStorage_1.setValueToLocalStorage)('favorites', state.favoritesList);
        },
        removeFromFavorites: function (state, action) {
            state.favoritesList = state.favoritesList.filter(function (car) { return car.id !== action.payload; });
            state.favoritesCount = state.favoritesList.length;
            (0, setValueToLocalStorage_1.setValueToLocalStorage)('favorites', state.favoritesList);
        },
    },
});
exports.removeFromFavorites = (_a = favoritesSlice.actions, _a.removeFromFavorites), exports.addToFavorites = _a.addToFavorites;
exports.default = favoritesSlice.reducer;
